import React from 'react';
import { Link } from 'react-router-dom';

export default function SchoolPageHeader({
  title,
  description,
  icon: Icon,
  actions = [],
  breadcrumbs = [],
}) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      {breadcrumbs.length > 0 && (
        <nav aria-label="Breadcrumb" className="mb-4 flex items-center gap-2 text-sm text-slate-500">
          {breadcrumbs.map((crumb, idx) => (
            <React.Fragment key={crumb.label}>
              {idx > 0 && <span>/</span>}
              {crumb.href ? <Link to={crumb.href} className="hover:text-slate-700">{crumb.label}</Link> : <span>{crumb.label}</span>}
            </React.Fragment>
          ))}
        </nav>
      )}

      <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
        <div className="flex items-start gap-3">
          {Icon && (
            <div className="rounded-xl bg-indigo-50 p-3 text-indigo-600">
              <Icon className="h-6 w-6" />
            </div>
          )}
          <div>
            <h1 className="text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
            {description && <p className="mt-1 text-sm text-slate-600">{description}</p>}
          </div>
        </div>

        {actions.length > 0 && (
          <div className="flex flex-wrap items-center gap-2">
            {actions.map((action) =>
              action.href ? (
                <Link
                  key={action.label}
                  to={action.href}
                  className={
                    action.variant === 'danger'
                      ? 'rounded-lg border border-red-300 px-3 py-2 text-sm font-medium text-red-700 hover:bg-red-50'
                      : action.variant === 'secondary'
                        ? 'rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50'
                        : 'rounded-lg bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-700'
                  }
                >
                  {action.label}
                </Link>
              ) : (
                <button
                  key={action.label}
                  onClick={action.onClick}
                  type="button"
                  disabled={action.disabled}
                  className={`${
                    action.variant === 'danger'
                      ? 'rounded-lg border border-red-300 px-3 py-2 text-sm font-medium text-red-700 hover:bg-red-50'
                      : action.variant === 'secondary'
                        ? 'rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50'
                        : 'rounded-lg bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-700'
                  } disabled:opacity-50 disabled:cursor-not-allowed`}
                >
                  {action.label}
                </button>
              ),
            )}
          </div>
        )}
      </div>
    </div>
  );
}
